/* Clipz-it, comportements des cartes produit (snippets/cz-carte-produit.liquid). Lot C du theme propre
   Horizon, 21/10/2026. Notre code : il reproduit le comportement des cartes du LIVE.
   1. Deuxieme image au survol, ordinateur seulement (overlay .cz-hover-img, effet gate par @media en CSS).
   2. Regle du +N (U05, R-314, R-356) : 3 pastilles au plus, puis un lien « +N » vers la fiche.
   3. Nom de la couleur sous les pastilles, au survol et au toucher (U03).
   4. Clic sur une pastille : image de la carte, prix et lien passent sur cette variante.
   5. Clic sur la photo : ouvre la fiche (la photo ne porte aucun lien, un seul lien produit par carte).
   7. Retour a la premiere vue (rewind du LIVE, acquis PC-12) : un balayage vers la gauche sur la derniere vue
      ramene a la premiere, un balayage vers la droite sur la premiere mene a la derniere. Ajout du 21/10/2026.
   6. Compte a rebours des ventes flash (format de la date : JJ/MM/AAAA HH:MM, metafield shop custom.flash_sale_end).
   Amelioration progressive : sans ce script, la carte reste lisible et cliquable par son lien. Zero tiret long. */
(function () {
  'use strict';

  function I(cle, repli) {
    var d = window.czI18n || {};
    return typeof d[cle] === 'string' && d[cle] !== '' ? d[cle] : repli;
  }

  function srcOf(img) {
    if (!img) return null;
    var s = img.getAttribute('src') || img.getAttribute('data-cz-src');
    if (s) return s;
    var ss = img.getAttribute('srcset') || '';
    return ss ? ss.trim().split(/\s+/)[0] : null;
  }

  function nomPastille(s) {
    var parts = (s.getAttribute('aria-label') || '').split(' ');
    parts.shift();
    return parts.join(' ');
  }

  function survol(carte) {
    if (carte.dataset.czHover) return;
    var imgs = carte.querySelectorAll('.cz-carte__vue img');
    if (imgs.length < 2) { carte.dataset.czHover = 'skip'; return; }
    var src = srcOf(imgs[1]);
    var boite = carte.querySelector('[data-cz-media]');
    if (!src || !boite) { carte.dataset.czHover = 'skip'; return; }
    var ov = document.createElement('img');
    ov.className = 'cz-hover-img';
    ov.alt = '';
    ov.setAttribute('aria-hidden', 'true');
    ov.decoding = 'async';
    ov.loading = 'lazy';
    var charge = false;
    carte.addEventListener('mouseenter', function () { if (charge) return; charge = true; ov.src = src; vues(carte); });
    boite.appendChild(ov);
    carte.dataset.czHover = '1';
  }

  function plusN(carte) {
    var sw = carte.querySelector('.swatches');
    if (!sw || sw.dataset.czPlusn) return;
    sw.dataset.czPlusn = '1';
    var items = [].filter.call(sw.children, function (n) { return n.classList && n.classList.contains('swatch-link'); });
    if (items.length <= 3) return;
    for (var i = 3; i < items.length; i++) items[i].style.display = 'none';
    var lien = carte.querySelector('a[href*="/products/"]');
    var reste = items.length - 3;
    var a = document.createElement('a');
    a.className = 'cz-plusn';
    a.textContent = '+' + reste;
    a.href = lien ? lien.getAttribute('href') : '#';
    a.setAttribute('aria-label', I('coloris', '@@').replace('@@', reste));
    sw.appendChild(a);
  }

  function nomCouleur(carte) {
    var sw = carte.querySelector('.swatches');
    if (!sw || sw.dataset.czColorName) return;
    sw.dataset.czColorName = '1';
    var items = sw.querySelectorAll('.swatch-link');
    if (!items.length) return;
    var label = document.createElement('span');
    label.className = 'cz-color-name';
    var choisi = sw.querySelector('.swatch-link[aria-pressed="true"]');
    if (choisi) label.textContent = nomPastille(choisi);
    sw.parentNode.insertBefore(label, sw.nextSibling);
    [].forEach.call(items, function (s) {
      s.addEventListener('mouseenter', function () { label.textContent = nomPastille(s); });
    });
  }

  function choisir(s) {
    var carte = s.closest('.cz-carte');
    if (!carte) return;
    [].forEach.call(carte.querySelectorAll('.swatch-link'), function (x) {
      if (x === s) x.setAttribute('aria-pressed', 'true'); else x.removeAttribute('aria-pressed');
    });
    var img = carte.querySelector('[data-cz-image-carte]');
    var src = s.getAttribute('data-cz-img');
    if (img && src) {
      img.setAttribute('src', src);
      /* 27/10/2026 vitesse : srcset recalculé depuis data-cz-img (mêmes largeurs que la carte), au lieu de 5 adresses par pastille dans le HTML. */
      var ss = /width=\d+/.test(src) ? [240, 300, 400, 540, 720].map(function (w) { return src.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ') : s.getAttribute('data-cz-srcset');
      if (ss) img.setAttribute('srcset', ss);
      var g = carte.querySelector('[data-cz-galerie]');
      if (g) g.scrollLeft = 0;
    }
    var href = s.getAttribute('data-href');
    if (href) {
      var lien = carte.querySelector('.cz-carte__texte');
      if (lien) lien.setAttribute('href', href);
      carte.setAttribute('data-product-url', href);
    }
    var pv = carte.querySelector('[data-cz-prix-vente]');
    var pb = carte.querySelector('[data-cz-prix-barre]');
    if (pv && s.getAttribute('data-cz-prix')) pv.textContent = s.getAttribute('data-cz-prix');
    if (pb) {
      var b = s.getAttribute('data-cz-barre') || '';
      pb.textContent = b;
      pb.hidden = b === '';
    }
    var rm = carte.querySelector('.cz-remise');
    if (rm) {
      var r = s.getAttribute('data-cz-remise') || '';
      rm.textContent = r;
      rm.hidden = r === '';
    }
    var lab = carte.querySelector('.cz-color-name');
    if (lab) lab.textContent = nomPastille(s);
  }

  document.addEventListener('click', function (e) {
    var s = e.target.closest('.cz-carte .swatch-link');
    if (s) { e.preventDefault(); e.stopPropagation(); choisir(s); return; }
    /* Bouton d'achat de la carte : le panneau d'achat rapide (snippets/cz-achat-rapide.liquid) l'intercepte en
       phase de capture. S'il n'est pas sur la page, le bouton mene a la fiche, jamais a un ajout aveugle. */
    var qa = e.target.closest('.cz-carte [data-ref="popup-toggle"]');
    if (qa) {
      if (!document.getElementById('cz-ar')) { e.preventDefault(); window.location.href = qa.getAttribute('data-product-page-url'); }
      return;
    }
    var m = e.target.closest('.cz-carte [data-cz-media]');
    if (m && !e.target.closest('button, a, [role="button"]')) {
      var carte = m.closest('.cz-carte');
      var url = carte && carte.getAttribute('data-product-url');
      if (url) window.location.href = url;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var s = e.target.closest && e.target.closest('.cz-carte .swatch-link');
    if (!s) return;
    e.preventDefault();
    choisir(s);
  });

  function rewind(carte) {
    var g = carte.querySelector('[data-cz-galerie]');
    if (!g || g.dataset.czRewind) return;
    g.dataset.czRewind = '1';
    var x0 = null, y0 = 0, s0 = 0;
    g.addEventListener('touchstart', function (e) {
      vues(g);
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; s0 = g.scrollLeft;
    }, { passive: true });
    g.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy)) return;
      var fin = g.scrollWidth - g.clientWidth;
      if (fin <= 0) return;
      if (dx < 0 && s0 >= fin - 2) g.scrollTo({ left: 0, behavior: 'smooth' });
      else if (dx > 0 && s0 <= 2) g.scrollTo({ left: fin, behavior: 'smooth' });
    }, { passive: true });
  }

  function dateFr(str) {
    /* 27/10/2026 : lecture tolérante. Le robot de traduction avait écrit « 16.09.2026 20:13 Uhr » en allemand : le minuteur restait
       figé sur « ... ». On accepte jour/mois/année avec / . ou - et heure:minute, quel que soit le texte autour. */
    var m = /(\d{1,2})\s*[\/.\-]\s*(\d{1,2})\s*[\/.\-]\s*(\d{4})\D+(\d{1,2})\s*[:.h]\s*(\d{2})/.exec(String(str || ''));
    if (!m) return null;
    return new Date(parseInt(m[3], 10), parseInt(m[2], 10) - 1, parseInt(m[1], 10), parseInt(m[4], 10), parseInt(m[5], 10));
  }
  function deux(n) { return (n < 10 ? '0' : '') + n; }
  function rebours() {
    var maintenant = Date.now();
    [].forEach.call(document.querySelectorAll('.cz-flash-countdown[data-end]'), function (el) {
      var fin = dateFr(el.getAttribute('data-end'));
      var span = el.querySelector('.cz-countdown-text');
      if (!fin || !span) return;
      var reste = fin.getTime() - maintenant;
      if (reste <= 0) { span.textContent = '⏱ ' + (el.getAttribute('data-cz-termine') || I('termine', 'Terminé')); return; } /* 27/10/2026 : libellé traduit porté par la carte (il sortait en français dans les 19 autres langues) */
      var h = Math.floor(reste / 3600000), m = Math.floor((reste % 3600000) / 60000), s = Math.floor((reste % 60000) / 1000);
      span.textContent = '⏱ ' + deux(h) + ':' + deux(m) + ':' + deux(s);
    });
  }

  /* 27/10/2026 vitesse (oui de Thibaut) : les pastilles en image (data-cz-bg) se posent après le chargement de la page, pour ne pas
     disputer la bande passante à la photo principale ; les cartes ajoutées ensuite (filtres, pagination) les reçoivent aussitôt. */
  function pastilles(racine) {
    [].forEach.call((racine || document).querySelectorAll('[data-cz-bg]'), function (el) {
      el.style.setProperty('--swatch-background', el.getAttribute('data-cz-bg'));
      el.removeAttribute('data-cz-bg');
    });
  }
  /* 27/10/2026 vitesse (PILOTAGE) : vues 2 et 3 des cartes (data-cz-src), posées avec les pastilles après la page, ou tout de
     suite pour une carte dont le client touche la galerie. Le chargement différé natif (loading=lazy) reste en place. */
  function vues(racine) {
    [].forEach.call((racine || document).querySelectorAll('img[data-cz-src]'), function (im) {
      if (im.getAttribute('data-cz-srcset')) im.setAttribute('srcset', im.getAttribute('data-cz-srcset'));
      im.setAttribute('src', im.getAttribute('data-cz-src'));
      im.removeAttribute('data-cz-src'); im.removeAttribute('data-cz-srcset');
    });
  }
  function pastillesApresChargement() {
    var go = function () { pastilles(document); vues(document); };
    var idle = window.requestIdleCallback || function (f) { setTimeout(f, 200); };
    if (document.readyState === 'complete') idle(go); else window.addEventListener('load', function () { idle(go); });
    if (window.MutationObserver) {
      new MutationObserver(function (ms) {
        if (document.readyState !== 'complete') return;
        for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
          var n = ms[i].addedNodes[j];
          if (n.nodeType === 1) pastilles(n.hasAttribute && n.hasAttribute('data-cz-bg') ? n.parentNode : n);
          if (n.nodeType === 1) vues(n.parentNode || n);
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function demarrer() {
    pastillesApresChargement();
    [].forEach.call(document.querySelectorAll('.cz-carte'), function (c) { survol(c); plusN(c); nomCouleur(c); rewind(c); });
    if (document.querySelector('.cz-flash-countdown[data-end]')) { rebours(); setInterval(rebours, 1000); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
